import request from '@/utils/requestVr'

// 查询列表分页
export function fetchList(query) {
    return request({
        url: '/vr/works/page',
        method: 'get',
        params: query,
    })
}
export function getObj(id) {
    return request({
        url: '/vr/works/detail?workId=' + id,
        method: 'get',
    })
}

export function delObj(data) {
    return request({
        url: '/vr/works/delete',
        method: 'post',
        data: data,
    })
}
export function editSys(data) {
    return request({
        url: '/vr/works/edit/sys',
        method: 'post',
        data: data,
    })
}
export function retryObj(data) {
    return request({
        url: '/vr/works/cut/image',
        method: 'post',
        data: data,
    })
}
export function addObj(data) {
    return request({
        url: '/vr/works/add',
        method: 'post',
        data: data,
    })
}